<template lang="pug">
  div.paginator.e-pagination
    span {{$translate('Показывать по')}}
    select(v-model="perPageModel" @change="changePerPage")
      option(value="10") 10
      option(value="20") 20
      option(value="50") 50
    div.page-nav
      span(v-if="currentPage > 1" @click="navigate('prev')").navigate.prev
      input(
      type='text' v-model="currentPage" @change="changeCurrentPage"
      )
      span {{$translate('из')}} {{ pageCount }}
      span(v-if="currentPage < pageCount" @click="navigate('next')").navigate.next

</template>

<script>
  import url from '../../utils/url.js'

  export default {
    name: 'e-pagination',
    data () {
      return {
        perPageModel: 20
      }
    },
    props: {
      currentPage: {
        type: [Number, String],
        default: 1
      },
      pageCount: {
        type: [Number, String],
        default: 0
      },
      totalCount: {
        type: [Number, String],
        default: 0
      },
      perPage: {
        type: [Number, String],
        default: 20
      },
      auto: {
        type: Boolean,
        default: true
      },
      paginateMethod: String
    },
    created () {
      this.perPageModel = this.perPage
    },
    watch: {
      'perPage': {
        handler: function (val, oldVal) {
          if (val) {
            this.perPageModel = val
          }
        }
      }
    },
    methods: {
      onSuccess (r) {
        // console.log('scroll')
        window.scrollTo(0, 0)
      },
      paginate (nextPage) {
        this.$emit('paginate', {
          'per-page': this.perPageModel,
          page: nextPage
        })
      },
      navigate (page) {
        this.$emit('navigate', page)
        if (this.auto) {
          let route = url.getRoute(this.$route)
          if (!route.query.page) {
            route.query.page = this.currentPage || 1
          }
          if (page === 'next') {
            route.query.page++
          } else if (page === 'prev') {
            route.query.page--
          }

          if (this.paginateMethod && this.paginateMethod === 'replace') {
            this.$router.replace(route, (r) => {
              this.onSuccess(r)
            })
          } else {
            this.$router.push(route, (r) => {
              this.onSuccess(r)
            })
          }

        } else {
          let nextPage = this.currentPage || 1
          if (page === 'next') {
            nextPage++
          } else if (page === 'prev') {
            nextPage--
          }
          this.paginate(nextPage)
        }
      },
      changeCurrentPage () {
        this.$emit('changePage', this.currentPage)
        if (this.auto) {
          let route = url.getRoute(this.$route)
          route.query.page = this.currentPage

          if (this.paginateMethod && this.paginateMethod === 'replace') {
            this.$router.replace(route, (r) => {
              this.onSuccess(r)
            })
          } else {
            this.$router.push(route, (r) => {
              this.onSuccess(r)
            })
          }
        } else {
          this.paginate(this.currentPage)
        }
      },
      changePerPage () {
        this.$emit('changePerPage', this.perPageModel)
        if (this.auto) {
          let route = url.getRoute(this.$route)
          route.query['per-page'] = this.perPageModel

          if (this.paginateMethod && this.paginateMethod === 'replace') {
            this.$router.replace(route, (r) => {
              this.onSuccess(r)
            })
          } else {
            this.$router.push(route, (r) => {
              this.onSuccess(r)
            })
          }
        } else {
          this.paginate(this.currentPage)
        }
      }
    }
  }
</script>
